import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M12 6h4v2h4V2H0v6h4V6h4v20H4v4h11.998v-4H12z\"></path><path d=\"M16 12v6h4v-2h2v10h-2v4h8v-4h-2V16h2v2h4v-6z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h32v32H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }